module.exports = __webpack_public_path__ + "static/media/background.deac9409.png";